export default __webpack_public_path__ + "static/media/manage_location_icon.5cd4eb21.svg";